import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { salesByProductSearchSchema } from '../../features/reports/operational-search'
import { SalesByProductPage } from '../../features/reports/sales-by-product-page'

export const Route = createFileRoute('/_app/sales-by-product')({
  staticData: { crumb: 'salesByProduct' },
  validateSearch: salesByProductSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: SalesByProductPage,
})
